import {actions as A} from '../constants/actions';

const defaultState = {
  data: {},
  loading: false,
  error: false,
  errorMessage: null
};

export default (state = defaultState, {type, payload}) => {
  switch (type) {
    case A.SEND_CONTACT_EMAIL:
      return {...state, loading: true, error: false, errorMessage: null, data: {}};

    case A.SEND_CONTACT_EMAIL_SUCCESS:
      return {...state, loading: false, error: false, errorMessage: null, data: payload};

    case A.SEND_CONTACT_EMAIL_FAILURE:
      return {...state, loading: false, error: true, errorMessage: payload};

    default:
      return state;
  }
}